import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Dialog as HeadlessDialog } from '@headlessui/react';
import { CommunitySchedulePicker, type CommunitySchedulePickerProps } from '@shared/dream-components';

import { scheduleFieldRender } from './scheduleFieldRender';

interface SchedulePostPanelProps
  extends Pick<CommunitySchedulePickerProps, 'action' | 'isSubmitting' | 'isSubmitDisabled'> {
  value: Date | undefined;
  nextUsualTime?: Date;
  onConfirm: (date: Date) => void;
  onCancel: () => void;
  autoFocus: boolean;
  queuedCount?: number;
  onViewQueue?: () => void;
}

// Takes the composer's place in its dialog. The picker's arrow and Cancel both go back to the composer.
export const SchedulePostPanel: FC<SchedulePostPanelProps> = ({
  value,
  nextUsualTime,
  onConfirm,
  onCancel,
  autoFocus,
  queuedCount,
  onViewQueue,
  ...sendProps
}) => {
  const { t, i18n } = useTranslation();

  return (
    <CommunitySchedulePicker
      value={value}
      nextUsualTime={nextUsualTime}
      onChange={onConfirm}
      onCancel={onCancel}
      {...sendProps}
      queuedCount={queuedCount}
      onViewQueue={onViewQueue}
      timeZone={Intl.DateTimeFormat().resolvedOptions().timeZone}
      locale={i18n.language}
      translate={(key, values) => t(key, values)}
      fieldRender={scheduleFieldRender(t('smartDateTimeField.legend'))}
      autoFocus={autoFocus}
      // The dialog title names the composer's dialog after the picker's visible title.
      titleAs={HeadlessDialog.Title}
    />
  );
};
